import { render, staticRenderFns } from "./survey-list.vue?vue&type=template&id=73a561fa&"
import script from "./survey-list.vue?vue&type=script&lang=js&"
export * from "./survey-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports